module.exports = __webpack_public_path__ + "img/rank-label.ff2f65b7.png";